<template>
  <div class="p-0 pb-3">
    <router-link
      class="tickets-card p-0 h-100"
      style="align-items: end"
      :to="{
        name: 'SmartOeeMarketFeatureDetails',
        params: { featureId: item.id },
      }"
    >
      <b-card
        :img-src="item.attachments.length ? item.attachments[0].url : defaultPicture"
        :img-alt="item.name"
        img-top
        no-body
        class="h-100 d-flex justify-content-between flex-column"
      >
        <b-card-title class="text-center pt-2">{{ item.name }}</b-card-title>
        <b-card-text class="px-4 text-muted">
          <span>{{ item.comm }}</span>
        </b-card-text>
        <b-card-footer class="text-center text-muted text-price-mobile mb-4">
          {{ item.price }}&euro;
          <s v-if="item.oldPrice !== 0" class="text-sale-mobile">{{ item.oldPrice }} &euro;</s>
        </b-card-footer>
        <div v-if="!item.isActive" class="p-3 position-absolute w-100" style="bottom: 0">
          <b-button class="btn-block" disabled variant="outline-success">
            {{ $t('features.getExtension') }}
          </b-button>
        </div>
        <feature-badge class="position-absolute" style="right: 0; top: 0" :status="item.status" />
      </b-card>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'FeatureListItem',
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      defaultPicture:
        'https://www.bootstrapdash.com/demo/corona/vue/preview/demo_2/img/img_2.1b4a771c.jpg',
    };
  },
};
</script>

<style lang="scss">
.text-price {
  font-size: 26px;
  white-space: nowrap;
}

.text-price-mobile {
  font-size: 24px;
}

.text-sale {
  font-size: 22px;
  text-decoration-color: red;
}

.text-sale-mobile {
  font-size: 20px;
  text-decoration-color: red;
}
</style>
